export default {
  // ActView
  act: 'Act',
  typeOf: 'Type of {entity}',
  actType: 'Act Type',
  addNewAct: 'Add New Act',
  showActs: 'Show Acts',
  createAct: 'Create Act',
  mustSelectActType: 'You must select an Act Type.',
  mustSelectPeriod: 'You must select a specific period to create an act.',
  from: 'from:',
  to: 'to:',

  // ActForm
  actCreatedSuccessfully: 'Act created.',
  actUpdatedSuccessfully: 'Act updated.',

  // ActComponent
  guests: 'Guests',
  identifier: 'Identifier',
  name: 'Name',
  email: 'Email',
  position: 'Position',
  otherInformation: 'Other Information',
  user: 'User',
  canEditAct: 'Can Edit the Act',
  attended: 'Attended',
  external: 'External',
  internal: 'Internal',
  editAttendee: 'Edit Attendee',
  removeAttendee: 'Remove Attendee',
  manageAttendees: 'Manage Attendees',
  addExternalAttendee: 'Add External Attendee',
  meetingTable: 'Meeting Table',
  editAspect: 'Edit Aspect',
  deleteAspect: 'Delete Aspect',
  addAspect: 'Add Aspect',
  treatedAspectsAndAgreements: 'TREATED ASPECTS AND AGREEMENTS',
  comments: 'COMMENTS',
  comment: 'Comment',
  addComment: 'Add Comment',
  reloadComments: 'Reload Comments.',
  commentsListUpdated: 'Comments list updated!',
  attachedFiles: 'ATTACHED FILES',
  saveAct: 'Save Act',
  createAspects: 'Create Aspects',
  createComment: 'Create comment',
  cannotSaveIfEmpty: 'Cannot save if empty.',
  deleteAspectConfirmation: 'Are you sure you want to remove the Aspect?',
  deleteCommentConfirmation: 'Are you sure you want to remove the Comment?',
  deleteFileConfirmation: 'Are you sure you want to remove the File?',
  userAlreadyInList: 'The selected user is already in the list.',
  deleteAttendeeConfirmation: 'Are you sure you want to remove the Attendee?',
  agreementDeleted: 'Agreement deleted.',
  noComments: 'There are no comments yet.',

  // SupportForm
  identifierType: 'Identifier Type',
  firstName: 'First Name',
  lastName: 'Last Name',
  attendeeCreatedSuccessfully: 'Attendee created.',
  attendeeUpdatedSuccessfully: 'Attendee updated.',

  // ActList
  noActsToShow: 'There are no Acts to show.',
  actsList: '{entity} List',
  number: 'Number',
  agreements: 'Agreements',
  fulfilledAgreements: 'Fulfilled Agreements',
  totalAgreements: 'Total Agreements',
  fulfilledTotals: 'Fulfilled / Total',
  open: 'Open',
  deleteActConfirmation: 'Are you sure you want to delete the Act?',
  actDeletedSuccessfully: 'Act deleted.',
  attachments: 'Attachments',
  noAttachments: 'No attached files.',

  // ActFiles
  removeFile: 'Remove File',
  selectOrDragFileHere: 'Select or drag file here...',
  dragFileHere: 'Drag file here...',
  ensureUploadBeforeSave: 'Make sure to upload the File before Saving.',
  uploadFile: 'Upload File',
  noAttachedFiles: 'There are no attachments',

  // UserList
  typeToFilter: 'Type to filter',
  usersPerPage: 'Users per page',
  typeToSearch: 'Type to search',
  professors: 'Professors',
  students: 'Students',
  users: 'Users',
  incorporate: 'Incorporate',

  // AspectAgreement
  addAgreement: 'Add Agreement',
  complianceDate: 'Compliance Date',
  agreement: 'Agreements',
  compliance: 'Compliance',
  responsibles: 'Responsibles',
  observations: 'Observations',
  editAgreement: 'Edit Agreement',
  deleteAgreement: 'Delete Agreement',
  createAgreement: 'Create Agreement',
  agreementUpdated: 'Agreement updated.',
  deleteAgreementConfirmation: 'Are you sure you want to delete the Agreement?',

  // AspectAgreementForm
  agreementCreated: 'Agreement created.',

  // ActComponent - Table fields
  role: 'Role',

  // ActComponent - Messages
  superUser: 'Super User',
  mustSelectAtLeastOneUser: 'You must select at least one user.',
}
